import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Package, PackageHost } from '../../Container';
import { timeMachine } from '../replay/ReplayCommands';
import { redo, undo } from './HistoryCommands';
import { HistoryManager } from './HistoryManager';
import { HistoryMechanics } from './HistoryMechanics';

export class HistoryPackage implements Package {

    public install = (host: PackageHost) => host
        .register(HistoryManager, 'singleton', 'startable')
        .register(HistoryMechanics, 'singleton', 'startable')
        .plug(inCommands(undo, redo, timeMachine));
}
